/* es6-iterator/valid-iterable */ function _(require, module, exports) {
    var isIterable = require(348) /* ./is-iterable */;
    module.exports = function (value) {
        if (!isIterable(value))
            throw new TypeError(value + " is not iterable");
        return value;
    };
}
